<template>
  <BaseServiceOfferModal
    v-model="showModal"
    :icon="WithdrawOfferModalIcon"
    :title="title"
    :description="description"
    :align-items="'center'"
  >
    <!-- Buttons slot -->
    <template #buttons>
      <div class="modal__action-buttons">
        <tertiary-button :disabled="isSubmitting" @click="showModal = false">{{
          cancelButtonText
        }}</tertiary-button>
        <primary-button :is-submitting="isSubmitting" @click="withdrawOffer">{{
          withdrawOfferButtonText
        }}</primary-button>
      </div>
    </template>
  </BaseServiceOfferModal>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import TertiaryButton from "@/components/Buttons/TertiaryButton.vue";
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import BaseServiceOfferModal from "./BaseServiceOfferModal.vue";
import WithdrawOfferModalIcon from "@/assets/img/document.svg";

const props = defineProps<{
  modelValue: boolean;
  messageWithdrawnText?: string;
  isEstimateRequest?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "withdraw-offer"): void;
}>();

const isSubmitting = ref(false);
const showMessageWithdrawnText = ref(false);

const showModal = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

// Hardcoded text in Norwegian
const title = computed(
  () => `Trekk tilbake ${props.isEstimateRequest ? "estimat" : "tilbud"}`,
);
const description = computed(() => [
  {
    content: `Når du trekker tilbake ${props.isEstimateRequest ? "estimatet" : "tilbudet"}, vil kunden bli varslet og det vil ikke være mulig å signere dette ${props.isEstimateRequest ? "estimatet" : "tilbudet"}. ${props.isEstimateRequest ? "Estimatet" : "Tilbudet"} vil fortsatt være tilgjengelig for både leverandør og kunde.`,
  },
]);
const cancelButtonText = "Avbryt";
const withdrawOfferButtonText = computed(
  () => `Trekk tilbake ${props.isEstimateRequest ? "estimat" : "tilbud"}`,
);

const closeModalWithDelay = () => {
  setTimeout(() => {
    isSubmitting.value = false;
    showModal.value = false;
  }, 2000);
};

const withdrawOffer = () => {
  isSubmitting.value = true;
  emit("withdraw-offer");
};

watch(
  () => props.messageWithdrawnText,
  (val) => {
    if (val) {
      showMessageWithdrawnText.value = true;
      closeModalWithDelay();
    }
  },
);
</script>

<style lang="scss" scoped>
.modal {
  &__action-response-text {
    margin-top: 40px;
    font-weight: 600;
    font-size: $font-size-base;
    line-height: 20px;
    text-align: center;
  }
  &__action-buttons {
    margin-top: 56px;
    display: flex;
    justify-content: flex-end;
    gap: 24px;

    > button {
      padding: 1rem 2.5rem;
      font-weight: 600;
      font-size: $font-size-sm;
      line-height: 20px;
    }
  }
}
</style>
